import { createTheme } from "@mui/material";

const cssVar = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim() ||
  "#fff";

export default createTheme({
  palette: {
    mode: "light",
    primary: {
      main: cssVar("--primary-dark"),
      light: cssVar("--primary"),
      dark: cssVar("--primary-dark"),
      contrastText: "#fff",
    },
    secondary: {
      main: cssVar("--primary"),
      contrastText: "#fff",
    },
    success: { main: "#80d51a" },
    warning: { main: "#ffca28" },
    error: { main: "#ff0000" },
    info: { main: "#ff9100" },
  },

  components: {
    MuiAvatar: {
      variants: [
        {
          props: { variant: "square" },
          style: {
            background:
              "linear-gradient(90deg, #df035d 18%, #cf0a64 41%, #b4166f 68%, #8e287f 96%, #892a81 100%)",
            borderRadius: "8px",
          },
        },
      ],
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiButton: {
      styleOverrides: {},
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          backgroundColor: "#f6f5f5",
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          whiteSpace: "normal",
          wordBreak: "break-all",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          "::before": {
            width: "3%",
            height: "2px",
            background: "#e5005b",
            border: "0",
            marginTop: "12px",
          },
          "::after": {
            height: "2px",
            width: "100%",
            background:
              "linear-gradient(90deg, #df035d 18%, #cf0a64 41%, #b4166f 68%, #8e287f 96%, #892a81 100%)",
            border: "0",
            marginTop: "12px",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: [
      "Barlow",
      "sans-serif",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});
